import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Checkmark as CheckmarkIcon, Minus } from '../icon';
import { checkmarkStyle } from './styles';
function Checkmark({ checked, disabled, error, isFocusVisible, isIndeterminate, }) {
    function renderIcon() {
        if (isIndeterminate) {
            return _jsx(Minus, { size: "small" });
        }
        if (checked) {
            return _jsx(CheckmarkIcon, { size: "small" });
        }
        return null;
    }
    return (_jsx("div", Object.assign({ css: checkmarkStyle({
            checked,
            disabled,
            hasError: error,
            isFocusVisible,
            isIndeterminate,
        }) }, { children: renderIcon() })));
}
export default Checkmark;
